import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';

export enum CertificateSendType {
  Zip = 0,
  SeparateFiles = 1,
}

@autoinject
export class SendCertificatesChoiceDialog {
  protected selectedSendType = CertificateSendType.Zip;

  constructor(
    private dialogController: DialogController,
  ) {}

  protected selectSendType(mode: CertificateSendType) {
    this.selectedSendType = mode;
  }

  protected confirm() {
    this.dialogController.ok(this.selectedSendType);
  }

  protected cancel() {
    this.dialogController.cancel();
  }
}
